import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the WidgetListDimensions state domain
 */

const selectWidgetListDimensionsDomain = (state) =>
  state.get("widgetListDimensions", initialState)

/**
 * Other specific selectors
 */
export const makeSelectIsLoading = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("isLoading")
  )

export const makeSelectListDimensionsTop = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsTop")
  )

export const makeSelectListDimensionsBottom = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsBottom")
  )

export const makeSelectListDimensionsTopBenchmark = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsTopBenchmark")
  )

export const makeSelectListDimensionsBottomBenchmark = () =>
  createSelector(selectWidgetListDimensionsDomain, (state) =>
    state.get("dimensionsBottomBenchmark")
  )

const makeSelectWidgetListDimensions = () =>
  createSelector(selectWidgetListDimensionsDomain, (substate) =>
    substate.toJS()
  )

export default makeSelectWidgetListDimensions
export { selectWidgetListDimensionsDomain }
